<template>
  <div id="idle" :class="{positions: helperHeightYn}">
    <Idle1 @staffCall="staffCallYn = true" @helper="helper" @emReady="emReady" v-if="idleType == 1" />
    <Idle2 @staffCall="staffCallYn = true" @helper="helper" @emReady="emReady" v-if="idleType == 2" />
    <Idle3 @staffCall="staffCallYn = true" @helper="helper" @emReady="emReady" v-if="idleType == 3" />

    <EmoneySelect
      @emCheck="
        emoneySelectYn = false;
        emoneyReadyYn = true;
        emoneyCheckYn = true;
      "
      @closeEmoneySelect="emoneySelectYn = false"
      @setEmoneyStatus="setEmoneyStatus"
      :staffCallYn="staffCallYn"
      :emoneySelectYn="emoneySelectYn"
    />

    <EmoneyReady
      @emCheck="
        emoneyReadyYn = false;
        emoneyCheckYn = true;
        emoney = 1000;
      "
      @closeEmoneyReady="emoneyReadyYn = false"
      :emoneyReadyYn="emoneyReadyYn"
      :paymethod="paymethod"
    />
    <EmoneyCheck @closeEmoneyCheck="emoneyCheckYn = false" :emoney="emoney" :emoneyCheckYn="emoneyCheckYn" />

    <Helper
      @setDarkYn="
        $store.commit('setDarkModeYn');
        helperYn = false;
      "
      @setHelper="
        helperYn = false;
        staffCallFinishYn = true;
      "
      @setHelperHeight="
        $store.commit('setHelperHeightYn');
        helperYn = false;
      "
      @closeHelper="helperYn = false"
      :helperYn="helperYn"
    />

    <StaffCall
      @closeStaffCall="staffCallYn = false"
      @setStaffCall="
        staffCallYn = false;
        staffCallFinishYn = true;
      "
      :staffCallYn="staffCallYn"
    />
    <StaffCallFinish @closeStaffCallFinish="staffCallFinishYn = false" :staffCallFinishYn="staffCallFinishYn" />

    <CloseModal @autoOpen="closeModalYn = false" :openTime="openTime" :closeTime="closeTime" v-if="closeModalYn" />

    <HealthyCheck @autoOpen="inspectYn = false" :openTime="openTime" :closeTime="closeTime" v-if="inspectYn" />

    <AlertVue :text="this.text" :message="this.message" v-if="alertYn" @setYes="setYes" />

    <InCompletePosTran :tranText="tranText" :tranFailYn="tranFailYn" v-if="inCompletePosTranYn" @closePosTran="closePosTran" />
  </div>
</template>
<script>
/* 기본 화면 */
import idle2 from '@/template/idle/Idle_1.vue';
import idle3 from '@/template/idle/Idle_2.vue';
import idle1 from '@/template/idle/Idle_3.vue';
/* 전자 머니 */
import emoneySelect from '@/components/modal/EmoneySelect.vue';
import emoneyReady from '@/components/modal/EmoneyReady.vue';
import emoneyCheck from '@/components/modal/EmoneyCheck.vue';
/* 장애인 */
import helper from '@/components/modal/Helper.vue';
/* 직원 호출 */
import staffCall from '@/components/modal/StaffCall.vue';
import staffCallFinish from '@/components/modal/StaffCallFinish.vue';
/* 개점폐점 */
import closeModal from '@/components/modal/CloseModal.vue';

/* 점검 팝업 */
import healthyCheck from '@/components/modal/HealthyCheck.vue';
/* 공통 alert 창 */
import alertVue from '@/components/modal/alert/AlertSuccess.vue';
/* 미완료 주문 처리 */
import inCompletePosTran from '@/components/modal/payment/InCompletePosTran.vue';

export default {
  name: 'idle',
  props: {},
  data() {
    return {
      message: '',
      idleType: this.$store.getters.getPosConfig.posConfig.orderScreenNo,
      emoneySelectYn: false, // 전자머니 선택
      emoneyReadyYn: false, // 전자머니 준비
      emoneyCheckYn: false, // 전자머니 완료
      emoney: 0, // 전자머니 금액
      helperYn: false, // 장애인
      staffCallYn: false, // 직원호출
      staffCallFinishYn: false, // 직원호출
      closeModalYn: false, // 개점폐점
      posConfig: null, // pos정보
      localeTimer: null, // locale 타이머
      darkModeYn: this.$store.getters.getDarkModeYn,
      inspectYn: false, //점검창
      openTime: null, // 개점시간
      closeTime: null, // 폐점시간
      yesterOpenTime: null, // 개점시간
      yesterCloseTime: null, // 폐점시간
      renewalTimer: null,
      renewalInterval: null,
      renewalStartYn: false,
      autoOpenInterval: null,
      paymethod: '',
      text: '',
      message: '',
      alertYn: false,
      inCompletePosTranYn: false,
      tranText: '',
      tranFailYn: false,
    };
  },
  unmounted() {
  },
  mounted() {
    //고대비
    this.$changeDarkModeIdle(this.darkModeYn);

    this.$store.dispatch('setOrgBaskets', []);
    this.posConfig = this.$store.getters.getPosConfig;

    // 언어 세팅
    // if (typeof this.$i18n == 'undefined') return;
    // if (this.posConfig.posConfig.defaultLanguage == 'KO') this.$i18n.locale = 'ko';
    // else if (this.posConfig.posConfig.defaultLanguage == 'JP') this.$i18n.locale = 'jp';
    // else if (this.posConfig.posConfig.defaultLanguage == 'EN') this.$i18n.locale = 'en';
    // else if (this.posConfig.posConfig.defaultLanguage == 'CH') this.$i18n.locale = 'cn';
    // else if (this.posConfig.posConfig.defaultLanguage == 'TW') this.$i18n.locale = 'tw';
  },
  created() {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkModeIdle(this.darkModeYn);
    },
  },
  beforeCreate() {
    this.$store.dispatch('setReset');
  },
  components: {
    /* 기본 화면 */
    Idle1: idle1,
    Idle2: idle2,
    Idle3: idle3,
    /* 전자머니 */
    EmoneySelect: emoneySelect,
    EmoneyReady: emoneyReady,
    EmoneyCheck: emoneyCheck,
    /* 장애인 */
    Helper: helper,
    /* 직원 호출 */
    StaffCall: staffCall,
    StaffCallFinish: staffCallFinish,
    /* 개점폐점 */
    CloseModal: closeModal,
    /* 점검 팝업 */
    HealthyCheck: healthyCheck,
    AlertVue: alertVue,
    InCompletePosTran: inCompletePosTran,
  },
  methods: {
    setYes() {
      this.text = '';
      this.message = '';
      this.alertYn = false;
    },
    setEmoneyStatus(paymethod) {
      this.emoneySelectYn = false;
      this.emoneyReadyYn = true;
      this.emoneyCheckYn = false;
      this.paymethod = paymethod;
    },
    emReady() {
      this.emoneySelectYn = true;
    },
    helper() {
      this.helperYn = true;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style scoped></style>
